const type = 'SET_CUSTOMER_ADDRESSES_HISTORY_ERROR';

const setCustomerAddressesHistoryError = (data = {}) => ({
  data,
  type,
});

export default setCustomerAddressesHistoryError;
